import React from 'react';
import FaIcon from './FaIcon';
import styles from '../styles/ConsentCategorySettings.module.css';

const DEFAULT_ICONS = {
  necessary: 'fas fa-lock',
  functional: 'fas fa-layer-group',
  analytics: 'fas fa-chart-bar',
  marketing: 'fas fa-bullhorn',
};

const ConsentCategorySettings = ({
  categories,
  labels,
  onCategoryToggle,
  onNecessaryAttempt,
  necessaryMessage = '',
  necessaryMessageId = 'consent-necessary-message',
  className = '',
  variant = 'default',
}) => {
  const handleNecessaryToggle = (event) => {
    event.preventDefault();
    onNecessaryAttempt?.();
  };

  const handleOptionalToggle = (category) => (event) => {
    onCategoryToggle?.(category, event.target.checked);
  };

  const rootClassName = [styles.categorySettings, variant === 'cmp' ? styles.cmp : '', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <div className={styles.settingsRowBlock}>
        <div className={styles.settingsRow}>
          <div className={styles.itemIcon}>
            <FaIcon className={DEFAULT_ICONS.necessary} />
          </div>
          <div className={styles.settingsRowInfo}>
            <span className={styles.settingsLabel}>{labels.necessary}</span>
            <p className={styles.settingsDescription}>{labels.necessaryDescription}</p>
          </div>
          <label className={`${styles.switch} ${styles.lockedSwitch}`}>
            <input
              type="checkbox"
              checked
              onChange={handleNecessaryToggle}
              aria-label={labels.necessary}
              aria-describedby={necessaryMessage ? necessaryMessageId : undefined}
            />
            <span className={`${styles.slider} ${styles.sliderChecked}`}></span>
          </label>
        </div>
        {necessaryMessage && (
          <p id={necessaryMessageId} className={styles.inlineErrorMessage} role="alert" aria-live="polite">
            {necessaryMessage}
          </p>
        )}
      </div>

      <div className={styles.settingsRow}>
        <div className={styles.itemIcon}>
          <FaIcon className={DEFAULT_ICONS.functional} />
        </div>
        <div className={styles.settingsRowInfo}>
          <span className={styles.settingsLabel}>{labels.functional}</span>
          <p className={styles.settingsDescription}>{labels.functionalDescription}</p>
        </div>
        <label className={styles.switch}>
          <input
            type="checkbox"
            checked={categories.functional === true}
            onChange={handleOptionalToggle('functional')}
            aria-label={labels.functional}
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      <div className={styles.settingsRow}>
        <div className={styles.itemIcon}>
          <FaIcon className={DEFAULT_ICONS.analytics} />
        </div>
        <div className={styles.settingsRowInfo}>
          <span className={styles.settingsLabel}>{labels.analytics}</span>
          <p className={styles.settingsDescription}>{labels.analyticsDescription}</p>
        </div>
        <label className={styles.switch}>
          <input
            type="checkbox"
            checked={categories.analytics === true}
            onChange={handleOptionalToggle('analytics')}
            aria-label={labels.analytics}
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      <div className={styles.settingsRow}>
        <div className={styles.itemIcon}>
          <FaIcon className={DEFAULT_ICONS.marketing} />
        </div>
        <div className={styles.settingsRowInfo}>
          <span className={styles.settingsLabel}>{labels.marketing}</span>
          <p className={styles.settingsDescription}>{labels.marketingDescription}</p>
        </div>
        <label className={styles.switch}>
          <input
            type="checkbox"
            checked={categories.marketing === true}
            onChange={handleOptionalToggle('marketing')}
            aria-label={labels.marketing}
          />
          <span className={styles.slider}></span>
        </label>
      </div>
    </div>
  );
};

export default ConsentCategorySettings;
